/**
 * Created by tofael on 11/5/17.
 */

exports.MAP = 'map';
exports.DONE = 'done';
exports.WAITING = 'waiting';
exports.NOTIFIED = 'notified';
exports.SLEEPING = 'sleeping';
exports.MISSIONS = 'missions';
exports.FOLLOW_UP = 'follow-up';
exports.DASHBOARD = 'dashboard';
exports.DISPATCHED = 'dispatched';
exports.NEW_PATIENT = 'new_patient';
exports.APPOINTMENT = 'appointment';
exports.VIEW_MISSION = 'view_mission';
exports.ON_FOLLOW_UP = 'on follow-up';
exports.VISITING_DOCTORS= 'visiting-doctors'
exports.CREATE_MISSION = 'create_mission';
exports.DOCTOR_CANCELED = 'doctor-canceled';
exports.PATIENT_CANCELED = 'patient-canceled';
exports.OPERATOR_CANCELED = 'operator-canceled';
exports.EXISTING_PATIENT = 'existing_patient';
exports.START_VISIT = 'start-visit';

exports.CALL = {
  calling: 'CALLING',
  sleeping: 'RETRY',
  waiting: ' NEW',
  done: 'DONE'
};

exports.LIST = {
  DOCTOR: 'doctor',
  APPLICATION: 'application',
  MISSION: 'mission',
  CALL: 'call',
  ADMIN: 'admin',
  CONSUMERS: 'consumers',
  OPERATORS: 'operators',
  VISITING_DOCTORS:"visiting-doctors",
  PENDING_PAYMENTS:"pending-payments",
  TIPS: 'apptips',
  APPOINTMENTS: 'appointments',
  SPECIALITIES: 'specialities'
};

exports.MISSION = {
  done: 'DONE',
  waiting: 'WAITING',
  notified: 'NOTIFIED',
  dispatched: 'DISPATCHED',
  arrived: 'DOCTOR ARRIVED',
  investigating: 'INVESTIGATING',
  'doctor-canceled': 'DOCTOR CANCELLED',
  'patient-canceled': 'PATIENT CANCELED',
  'follow-up': 'FOLLOW-UP',
  'start-visit': 'Doctor Started',
  'on follow-up': 'ON FOLLOW-UP',
  billed: 'BILLED',
  paid: 'PAID'
};



// WEBPACK FOOTER //
// ./src/utility/app-constants.js